import React, { PureComponent } from 'react'
import styled from 'styled-components/native'
import Touchable from '../Touchable'
import theme from '../../../styles/theme'

import Spinner from '../Spinner'

export const TransParentTouchable = styled(Touchable)`
  border-width: 1px;
  border-color: ${theme.colours.black};
  padding: ${theme.gutterUnit}px;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  ${props => props.block ? 'height: 100%' : ''}
`

export default class Button extends PureComponent {
  render () {
    const {
      children,

      primary,
      secondary,
      third,
      lightgrey,
      mediumgrey,
      darkgrey,
      grey,
      colour,
      white,

      rounded,
      block,
      noborder,
      borderColour,

      vertical,
      inProgress,

      styles,

      ...props
    } = this.props
    let _styles = styles
    if (!_styles) _styles = []

    if (primary) {
      _styles.push({ backgroundColor: theme.colours.primary })
    }

    if (secondary) {
      _styles.push({ backgroundColor: theme.colours.secondary })
    }

    if (third) {
      _styles.push({ backgroundColor: theme.colours.third })
    }

    if (lightgrey) {
      _styles.push({ backgroundColor: theme.colours.lightgrey })
    }

    if (mediumgrey) {
      _styles.push({ backgroundColor: theme.colours.mediumgrey })
    }

    if (darkgrey) {
      _styles.push({ backgroundColor: theme.colours.darkgrey })
    }

    if (grey) {
      _styles.push({ backgroundColor: theme.colours.grey })
    }

    if (white) {
      _styles.push({ backgroundColor: theme.colours.white })
    }

    if (colour) {
      _styles.push({ backgroundColor: colour })
    }

    if (rounded) {
      _styles.push({ borderRadius: 0.5 * theme.gutterUnit })
    }

    if (vertical) {
      _styles.push({ flexDirection: 'column' })
    }

    if (noborder) {
      _styles.push({ borderWidth: 0 })
    }

    if (borderColour) {
      _styles.push({ borderColor: borderColour })
    }

    return (
      <TransParentTouchable
        block={block}
        style={_styles}
        {...props}
      >
        {inProgress ? <Spinner white /> : children}
      </TransParentTouchable>
    )
  }
}
